// extracted by mini-css-extract-plugin
module.exports = {"tabs":"progress-module--tabs--2gC0_","timeline":"progress-module--timeline--3g2jk"};